import { sessionHasEnded, sessionIdentity, startSessionRenewal } from '../../lib/auth-session';
import { useEffect, useSyncExternalStore, type ReactNode } from 'react';

function subscribeSession(listener: () => void) {
  window.addEventListener('nissei-session-change', listener);
  return () => window.removeEventListener('nissei-session-change', listener);
}
function sessionSnapshot() {
  return getTokens()?.accessToken ?? '';
}
import { Navigate, useLocation } from 'react-router-dom';
import { AccessProvider } from '../../lib/access/AccessProvider';
import { getTokens, isTokenExpired } from '../../lib/auth-storage';

interface RequireAuthProps {
  children: ReactNode;
}

export function RequireAuth({ children }: RequireAuthProps) {
  const session = useSyncExternalStore(subscribeSession, sessionSnapshot);
  useEffect(startSessionRenewal, []);
  const location = useLocation();
  const tokens = getTokens();

  if (!tokens || (isTokenExpired(tokens) && !tokens.refreshToken)) {
    // Preserve the attempted path so LoginPage's existing
    // `redirectTo = location.state?.from ?? '/admin/masterdata/products'`
    // logic sends the user back to where they were actually headed, not
    // just the default landing page.
    return (
      <Navigate to="/login" state={{ from: `${location.pathname}${location.search}`, ...((sessionHasEnded() || (tokens && isTokenExpired(tokens))) ? { sessionEnded: true } : {}) }} replace />
    );
  }

  return (
    <AccessProvider key={sessionIdentity(session)} showMessages={false}>
      {children}
    </AccessProvider>
  );
}

export default RequireAuth;
